import { render } from "./BottomMainMenu.vue?vue&type=template&id=7fefc235&scoped=true"
import script from "./BottomMainMenu.vue?vue&type=script&lang=js"
export * from "./BottomMainMenu.vue?vue&type=script&lang=js"

import "./BottomMainMenu.vue?vue&type=style&index=0&id=7fefc235&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fefc235"]])

export default __exports__